import { render } from "./HeroiconsOutlinePause.vue?vue&type=template&id=a00a85a2"
const script = {}

import exportComponent from "/Users/mior/Projects/laravel/nova/silver-surfer/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsOutlinePause.vue"]])

export default __exports__